import m from 'mithril'

export default {
  view: vnode => {
    const image = require('./toilets.jpg')
    

    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-09-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">Faciliteter i Camp Century:</h3>
          <ul className="log-book-text">
          <li>a. Beboelse</li>
          <li>b. Køkken og messe</li>
          <li>c. Latriner og bruserum</li>
          <li>d. Fælles opholdsrum og biograf</li>
          <li>e. Bibliotek og hobbyværksteder</li>
          <li>f. Apotek, operationsstue, 10-sengs hospitalsstue</li>
          <li>g. Vaskeri</li>
          <li>h. Postkontor</li>
          <li>i. Laboratorier</li>
          <li>j. Kølerumk. </li>
          <li>k. POL tanke</li>
          <li>l. Kommunikationscenter</li>
          <li>m. Udstyrsrum og værksteder</li>
          <li>n.Forsynings- og opbevaringsområde</li>
          <li>o. Atomkraft-drevet el-anlæg (samt standby dieseldrevet el-anlæg)</li>
          <li>p. Administrative kontorbygninger</li>
          <li>q. Depotrum</li>
          <li>r. Kapel</li>
          </ul>

          <figure className="log-book-figure">
            <img src={image} className="log-book-img" />
            <figcaption className="log-book-figcaption">
            Toiletbesøg foregår på en lang række og uden det store privatliv. Afføring og kloakvand giver alvorlige gener i Camp Century
            </figcaption>
          </figure>
        </div>
      </div>
    )
  }
}
